import { render, staticRenderFns } from "./CommunityFeedIcon.vue?vue&type=template&id=6a125666"
import script from "./CommunityFeedIcon.vue?vue&type=script&lang=js"
export * from "./CommunityFeedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports